import { Tag, type TableColumnsType, Button, Table } from "antd"
import { BonosFijosPorFranquiciado } from "hooks/Franquiciados/useBonosFranquiciados"

import { EditOutlined } from "@ant-design/icons"

type Props = {
  dataSource: BonosFijosPorFranquiciado[]
  onClickButtonEdit(record: BonosFijosPorFranquiciado): void
}

export function SubTableBonos({ dataSource, onClickButtonEdit }: Props) {
  const columns: TableColumnsType<BonosFijosPorFranquiciado> = [
    {
      title: "Franquiciado",
      dataIndex: "nombres",
      key: "nombres",
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
    },
    {
      title: "Fecha de asignación",
      dataIndex: "fecha",
      key: "fecha",
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      align: "center",
      render: (value: boolean) => (value ? <Tag color="success">Activo</Tag> : <Tag color="default">Inactivo</Tag>),
    },
    {
      title: "Modificar",
      dataIndex: "cod_franquiciado",
      key: "editar",
      align: "center",
      render: (_, record) => (
        <Button
          icon={<EditOutlined style={{ fontSize: "1.3rem" }} />}
          type="text"
          block
          onClick={() => onClickButtonEdit(record)}
        />
      ),
    },
  ]

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      size="small"
      pagination={false}
      scroll={{ x: true }}
      rowKey="cod_franquiciado"
    />
  )
}
